import { useQueryClient } from "@tanstack/react-query";

type QueryKey = (string | number | undefined)[];

export function usePrimeFromCollection<T>(
    collection: T[],
    getQueryKey: (item: T) => QueryKey
): void {
    const queryClient = useQueryClient();

    for (const item of collection) {
        const queryKey = getQueryKey(item);
        if (!queryClient.getQueryData(queryKey)) {
            queryClient.setQueryData(queryKey, item);
        }
    }
}
